/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Foot_LinkInputs */

const en_rd_foot_link = /** @type {(inputs: Rd_Foot_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent readiness`)
};

const id_rd_foot_link = /** @type {(inputs: Rd_Foot_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesiapan agent`)
};

/**
* | output |
* | --- |
* | "Agent readiness" |
*
* @param {Rd_Foot_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_foot_link = /** @type {((inputs?: Rd_Foot_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Foot_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_foot_link(inputs)
	return en_rd_foot_link(inputs)
});